/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Listen_In_Mobile_Or_Web_AppInputs */

const en_common_listen_in_mobile_or_web_app = /** @type {(inputs: Common_Listen_In_Mobile_Or_Web_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen in mobile or web app`)
};

const es_common_listen_in_mobile_or_web_app = /** @type {(inputs: Common_Listen_In_Mobile_Or_Web_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escúchala en móvil o web`)
};

/**
* | output |
* | --- |
* | "Listen in mobile or web app" |
*
* @param {Common_Listen_In_Mobile_Or_Web_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_listen_in_mobile_or_web_app = /** @type {((inputs?: Common_Listen_In_Mobile_Or_Web_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Listen_In_Mobile_Or_Web_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_listen_in_mobile_or_web_app(inputs)
	return en_common_listen_in_mobile_or_web_app(inputs)
});